/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CurrentCompanyUser } from './CurrentCompanyUser';
import {
    CurrentCompanyUserFromJSON,
    CurrentCompanyUserFromJSONTyped,
    CurrentCompanyUserToJSON,
} from './CurrentCompanyUser';

/**
 * 
 * @export
 * @interface GetCurrentCompanyUserResponse
 */
export interface GetCurrentCompanyUserResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetCurrentCompanyUserResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCompanyUserResponse
     */
    message: string;
    /**
     * 
     * @type {CurrentCompanyUser}
     * @memberof GetCurrentCompanyUserResponse
     */
    data: CurrentCompanyUser;
}

/**
 * Check if a given object implements the GetCurrentCompanyUserResponse interface.
 */
export function instanceOfGetCurrentCompanyUserResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetCurrentCompanyUserResponseFromJSON(json: any): GetCurrentCompanyUserResponse {
    return GetCurrentCompanyUserResponseFromJSONTyped(json, false);
}

export function GetCurrentCompanyUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentCompanyUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': CurrentCompanyUserFromJSON(json['data']),
    };
}

export function GetCurrentCompanyUserResponseToJSON(value?: GetCurrentCompanyUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': CurrentCompanyUserToJSON(value.data),
    };
}

